var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-42",
    "data-name": "50_Kids_Icons-42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#eb7fa8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4841",
    "data-name": "Group 4841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4824",
    "data-name": "Group 4824",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M142.385,255.43c1.13,2.677.515,5.278-1.374,5.81s-4.337-1.205-5.467-3.882-.515-5.278,1.374-5.811S141.255,252.754,142.385,255.43Z",
    transform: "translate(-113.888 -212.163)",
    fill: "#b35c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M326.56,255.43c-1.13,2.677-.514,5.278,1.375,5.81s4.337-1.205,5.466-3.882.515-5.278-1.374-5.811S327.691,252.754,326.56,255.43Z",
    transform: "translate(-275.058 -212.163)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4825",
    "data-name": "Group 4825",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M115.32,421.249l-.009-.145c0-8.821-3.3-17.367-7.334-18.995l-17.171-6.918a22.748,22.748,0,0,0-14.668-.019L58.72,402.131c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145Z",
    transform: "translate(-43.347 -332.409)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4826",
    "data-name": "Group 4826",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M224.005,272.134a6.856,6.856,0,0,1-6.856,6.856h-.831a6.856,6.856,0,0,1-6.856-6.856v-17.66a6.856,6.856,0,0,1,6.856-6.856h.831a6.856,6.856,0,0,1,6.856,6.856Z",
    transform: "translate(-176.734 -208.928)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    "data-name": "Group 4828",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4827",
    "data-name": "Group 4827",
    transform: "translate(25.245 17.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M191.077,138.463a14.755,14.755,0,0,1-14.755,14.755h0a14.755,14.755,0,0,1-14.755-14.755V126.19a14.755,14.755,0,0,1,14.755-14.755h0a14.755,14.755,0,0,1,14.755,14.755Z",
    transform: "translate(-161.567 -111.435)",
    fill: "#c67c47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4829",
    "data-name": "Group 4829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_270",
    "data-name": "Ellipse 270",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(32.636 43.105)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_271",
    "data-name": "Ellipse 271",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(43.951 43.105)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    "data-name": "Group 4830",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M162.465,96.212c-9.566,0-17.321,8.405-17.321,18.774a19.9,19.9,0,0,0,2.349,9.444l1.066-9.04a6.291,6.291,0,0,1,6.248-5.555h15.315a6.291,6.291,0,0,1,6.248,5.553l1.068,9.042a19.9,19.9,0,0,0,2.348-9.444C179.786,104.617,172.031,96.212,162.465,96.212Z",
    transform: "translate(-122.465 -81.179)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4831",
    "data-name": "Group 4831",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M243.245,291.867a2.628,2.628,0,0,1-5.13.593,2.782,2.782,0,0,0-.126.783,2.814,2.814,0,1,0,5.629,0A2.776,2.776,0,0,0,243.245,291.867Z",
    transform: "translate(-200.803 -246.263)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4832",
    "data-name": "Group 4832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M115.311,435.37c0-8.821-3.3-17.367-7.334-18.995l-13.653-5.5a12.058,12.058,0,0,1-21.928.058L58.72,416.4c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145H115.32Z",
    transform: "translate(-43.347 -346.676)",
    fill: "#2961a5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    "data-name": "Group 4833",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M159.343,201.555h0A3.343,3.343,0,0,1,156,198.212V190.57a3.343,3.343,0,0,1,3.343-3.343h0a3.343,3.343,0,0,1,3.343,3.343v7.642A3.343,3.343,0,0,1,159.343,201.555Z",
    transform: "translate(-131.625 -157.973)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M196.238,159.8h0a3.789,3.789,0,0,1-3.789-3.789v-8.661a3.789,3.789,0,0,1,3.789-3.789h0a3.789,3.789,0,0,1,3.789,3.789v8.661A3.789,3.789,0,0,1,196.238,159.8Z",
    transform: "translate(-162.379 -121.128)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M235.539,151.938h0a3.789,3.789,0,0,1-3.789-3.789v-8.661a3.789,3.789,0,0,1,3.789-3.789h0a3.789,3.789,0,0,1,3.789,3.789v8.661A3.789,3.789,0,0,1,235.539,151.938Z",
    transform: "translate(-195.539 -114.496)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M274.84,160.671h0a3.789,3.789,0,0,1-3.789-3.789v-8.661a3.789,3.789,0,0,1,3.789-3.789h0a3.789,3.789,0,0,1,3.789,3.789v8.661A3.789,3.789,0,0,1,274.84,160.671Z",
    transform: "translate(-228.699 -121.864)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M316.549,197.188h0a3.343,3.343,0,0,1-3.343-3.343V186.2a3.343,3.343,0,0,1,3.343-3.343h0a3.343,3.343,0,0,1,3.343,3.343v7.642A3.343,3.343,0,0,1,316.549,197.188Z",
    transform: "translate(-264.268 -154.288)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 13.646,
    cy: 5.458,
    rx: 13.646,
    ry: 5.458,
    transform: "translate(25.74 23.113)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    "data-name": "Group 4836",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4834",
    "data-name": "Group 4834",
    transform: "translate(18.906 12.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_273",
    "data-name": "Ellipse 273",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(0 18.75)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_274",
    "data-name": "Ellipse 274",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(0 12.5)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_275",
    "data-name": "Ellipse 275",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(3.125 6.25)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(7.813 1.563)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_277",
    "data-name": "Ellipse 277",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(14.063)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4835",
    "data-name": "Group 4835",
    transform: "translate(39.219 12.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_278",
    "data-name": "Ellipse 278",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(14.063 18.75)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_279",
    "data-name": "Ellipse 279",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(14.063 12.5)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(10.938 6.25)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    transform: "translate(6.25 1.563)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_282",
    "data-name": "Ellipse 282",
    cx: 3.906,
    cy: 3.906,
    r: 3.906,
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4837",
    "data-name": "Group 4837",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M228.749,326.367a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.163-.625-3.015-1.856-1.856Z",
    transform: "translate(-185.625 -275.063)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    "data-name": "Group 4840",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4838",
    "data-name": "Group 4838",
    transform: "translate(30.557 40.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M197.161,259.1a9.168,9.168,0,0,1,4.327-.877,1.053,1.053,0,0,0,0-2.105,11.422,11.422,0,0,0-5.39,1.165c-1.215.607-.148,2.423,1.063,1.818Z",
    transform: "translate(-195.562 -256.113)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4839",
    "data-name": "Group 4839",
    transform: "translate(43.057 40.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M280.907,259.1a9.168,9.168,0,0,0-4.328-.877,1.053,1.053,0,0,1,0-2.105,11.423,11.423,0,0,1,5.39,1.165c1.215.607.148,2.423-1.062,1.818Z",
    transform: "translate(-275.562 -256.113)",
    fill: "#3d2a3d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar13);
export default __webpack_public_path__ + "static/media/avatar13.a92bb4caa3f81f8e3b2f652caf5c8bfc.svg";
export { ForwardRef as ReactComponent };